<template>
  <div>
    <!-- SECCIONES -->
      <vs-tabs v-if="isMounted" position="top" v-model="activeTab" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
        <vs-tab :label="group.title" icon-pack="feather" :icon="group.icon" v-for="(group, i) in sectionGroups" :key="i">
          <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
            <vx-card no-shadow >
              <vx-card v-for="section in getSectionsForGroup(group)" :key="section.data.id" :title="section.data.public_name" class="mb-5">
                <p class="mb-4" v-if="section.data.public_description != null">{{section.data.public_description}}</p>

                <div class="vx-row">
                  <template v-for="f in section.data.fields">

                    <!-- Campos automaticos -->
                    <form-field
                      :ref="'section' + section.data.id"
                      v-if="isAutoFormField(f)"
                      :key="f.id"
                      :f="f"
                      :keepDisabled="isDisabled"
                      :dataContainer="getContainerForField(section, f)"
                      :collectionsRoot="collections"
                      :onChangeReceptor="onFieldChange"
                      :hasBackofficeAccess="hasBackofficeAccess"
                      :blockedByDocument="f.blockedByDocument"
                      :inputClassLarge="true"
                      :evaluator="evaluateCondition" />

                    <!-- Campos y controles especiales -->

                    <technology-selector-control
                    :key="f.id"
                    :f="f"
                    :project_id="id"
                    :familyGroups="collections.family_groups"
                    v-else-if="f.fname == 'technologies_list_selector'" />

                    <applicant-references-control
                    :key="f.id"
                    :applicant_id="currentClientUserId"
                    v-else-if="f.fname == 'applicant_references'" />

                    <address-divider
                      :key="f.id"
                      v-else-if="f.fname == 'address_divider' && client_should_be_working_and_not_the_same_address" />

                  </template>
                </div>

                <!-- Save Button -->
                <div class="vx-row" v-if="!isDisabled && !section.data.skipBtn">
                  <div class="vx-col w-full">
                    <div class="flex flex-wrap items-center justify-end">
                      <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                    </div>
                  </div>
                </div>

                 <template v-if="section.data.documentFields.length > 0">
                  <vs-divider></vs-divider>
                  <h6 class="mb-3">Documentos</h6>
                  <div class="vx-row">
                    <document-upload
                    v-for="df in section.data.documentFields"
                    :key="df.id"
                    :target_id="df.target_id"
                    :f="df.formField"
                    :doc="df.documentSet"
                    :inputClassLarge="false"
                    :disabled="isDisabled"
                    :evaluator="evaluateCondition"
                    :from_project_id="id"
                    :loadedState="df.loadedState"
                    />
                  </div>
                </template>

              </vx-card>

            </vx-card>
          </div>
        </vs-tab>

      </vs-tabs>

  <load-error v-if="failed" />

  </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';
import dateHelper from '@components/mixins/dateHelper';
import formHelper from '@components/mixins/formHelper';
import docsHelper from '@components/mixins/docsHelper';
import FormField from '@components/forms/FormField.vue'
import TechnologySelectorControl from '@technologies/TechnologySelectorControl'
import TechnologyLocationEvidencesControl from '@technologies/TechnologyLocationEvidencesControl.vue'
import AddressDivider from '@components/forms/AddressDivider.vue'

const pfTabsDefs = [
  { slug: "revision_pf", title: "Concentrado de información", icon: "icon-book-open", sections:[14, 33, 19, 20, 21, 31] },
];

const pmTabsDefs = [
  { slug: "revision_pm", title: "Concentrado de información", icon: "icon-book-open", sections:[26, 27, 28, 31] },
];

const sectionsToContainers = [
  { id: 16, containers: [{db:'addresses', path:'client.user.business.address'}] },
  { id: 26, containers: [{db:'business_profiles', path:'client.user.business'}] },
  { id: 27, containers: [
    {db:'personal_profiles', path:'client.user.business.personal'},
    {db:'users', path:'client.user'}
  ]},
  { id: 28, containers: [
    {db:'business_profiles', path:'client.user.business'},
    {db:'business_credit_profiles', path:'client.user.business.credit_profile'}
  ]},
  { id: 29, containers: [{db:'business_profiles', path:'client.user.business'}] },
  { id: 52, containers: [{db:'addresses', path:'client.user.business.personal.address'}] },
  { id: 30, containers: [
    {db:'personal_profiles', path:'client.user.business.personal'},
    {db:'personal_credit_profiles', path:'client.user.business.personal.credit_profile'},
    {db:'guarantee_profiles', path:'client.user.business.personal.guarantee_profile'}
  ]},

  { id: 14, containers: [
    {db:'personal_profiles', path:'client.user.personal'},
    {db:'users', path:'client.user'},
    {db:'personal_credit_profiles', path:'client.user.personal.credit_profile'},
    {db:'projects', path:'base'},
    {db:'clients', path:'client'}
  ]},
  { id: 31, containers: [{db:'projects', path:'base'}, {db:'clients', path:'client'}] },
  { id: 32, containers: [{db:'addresses', path:'client.user.personal.address'}] },
  { id: 33, containers: [
    {db:'personal_credit_profiles', path:'client.user.personal.credit_profile'},
    {db:'personal_profiles', path:'client.user.personal'},
    // {db:'addresses', path:'client.user.personal.credit_profile.address'},
  ]},
  { id: 34, containers: [{db:'project_related_profiles', path:'related_profiles', arrayDefs: {}}] },
  { id: 35, containers: [{db:'bank_accounts', path:'client.user.personal.bank_accounts', arrayDefs: {getFirst: true, onNull: 'newBankAccount'}}] },
  { id: 19, containers: [
    {db:'guarantee_profiles', path:'client.user.personal.guarantee_profile'},
    {db:'personal_profiles', path:'client.user.personal.guarantee_profile.personal'},
    {db:'personal_credit_profiles', path:'client.user.personal.guarantee_profile.personal.credit_profile'},
  ]},
  { id: 20, containers: [{db:'addresses', path:'client.user.personal.guarantee_profile.personal.address'}] }, // revisar
  { id: 21, containers: [
    {db:'personal_profiles', path:'client.user.personal.guarantee_profile.personal'},
    {db:'guarantee_profiles', path:'client.user.personal.guarantee_profile'},
    {db:'personal_credit_profiles', path:'client.user.personal.guarantee_profile.personal.credit_profile'},
  ]}, // revisar
  { id: 36, containers: [{db:'projects', path:'base'}, {db:'clients', path:'client'}] },

  { id: 44, containers: [{db:'client_contracts', path:'contracts', arrayDefs: {}}] },
  { id: 47, containers: [
    {db:'projects', path:'base'},
    {db:'project_finances', path:'finance'},
    {db:'master_clients_amortizations', path:'amortizations', arrayDefs: {}},
  ]},
  { id: 50, containers: [{db:'project_finances', path:'finance'}]},
  { id: 51, containers: [{db:'project_finances', path:'finance'}]},
  { id: 56, containers: []},
];

const requiredObjects = [
  'amortizations',
  'contracts',
  'finance',
  'relatedProfiles',
  'client.user.personal.address',
  'client.user.personal.creditProfile',
  'client.user.personal.bankAccounts',

  'client.user.business.address',
  'client.user.business.personal.address',
  'client.user.business.personal.creditProfile',
  // 'client.user.business.guaranteeProfile',
  'client.user.business.bankAccounts',
  'splits',
  'supplier.user',
  // 'client.user.personal.creditProfile.address',
];

const arrayPaths = ['contracts', 'client.user.personal.bank_accounts', 'related_profiles', 'amortizations'];

const addressMinDefault = {
  id: null,
  country_id: null,
  city_id: null,
};
const fiscalAddressMinDefault = {
  id: null,
  country_id: null,
  city_id: null,
  address_equals_fiscal_address: null
}

const genderDefs = [
  {k: 1, v: "HOMBRE"},
  {k: 2, v: "MUJER"},
];

const verifiedEnumValue = "verificado";

export default {
  mixins: [formHelper, inputHelper, dateHelper, docsHelper],
  props: ['id', "isDisabled", "person_type"],
  data(){
    return {
      errorCode: 0,
      onError: false,

      pmClientType: 0,
      pfClientType: 1,

      flow_id_pf: 4,
      flow_id_pm: 5,

      pfaeExtraSection: 15,
      PFAE_TAX_PROFILE: 1,

      isMaster: null,

      loading: false,
      isMounted: false,
      isRefreshing: false,
      errorMssg: '',
      successMssg: '',
      failed: false,

      flow: {},
      allSections: [],
      sectionGroups: [],

      documentsStates: [],

      tabs: [],

      isMoral: false,
      isPfae: false,
      activeTab: 0,
      isRealPFAE: false,

      missing: {
        enterprise: '',
        acredit: '',
        contact: '',
        residence: '',
        bank: ''
      },

      collections: {
        cities: [],
        owner_cities: [],
        employer_cities: [],
        fiscal_cities: [],
        states: [],
        countries: [],
        personal_occupations: [],
        family_groups: [],
        tools: [],
        business_activities: [],
        genders: genderDefs,
        terms: [],
        banks: [],
        cover_images: [],
      },

      // objeto principal
      base: {},

      // auxiliares para evaluacion de condiciones
      mexicoCountryId: 700,
      marriedMaritalStatusId: 2,

      // objetos para actualizaciones
      basePayload: {},
      validatedFields: [],
      totalFields: 0,
      totalValidFields: 0,
      totalInvalidFields: 0,

      validatedDocuments: [],
      allDocumentFields: [],

      cpAddressSource: null,
    }
  },
  components: {
    FormField,
    TechnologySelectorControl,
    TechnologyLocationEvidencesControl,
    AddressDivider
  },
  computed: {
    hasBackofficeAccess(){
      return this.$acl.check('isBackoffice');
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 2000
    },
    currentProjectId(){
      return this.id;
    },
    currentClientUserId(){
      return this.base.client_id;
    },
    personal(){
      return this.base.client.user.personal;
    },
    business(){
      return this.base.client.user.business;
    },
    pf_guarantee(){
      return this.personal.guarantee_profile;
    },
    pf_guarantee_personal(){
      if(this.pf_guarantee){
        return this.personal.guarantee_profile.personal;
      }
      return null;
    },
    pf_guarantee_address(){
      if(this.pf_guarantee && this.pf_guarantee_personal){
        return this.personal.guarantee_profile.personal.address;
      }
      return null;
    },
    legal_owner_document_required(){
      if(this.business){
        return this.business.power_proof_required;
      }
      return false;
    },
    should_send_pf_guarantee_income_files(){
      if(this.pf_guarantee){
        return this.pf_guarantee.income_files_required;
      }
      return false;
    },
    should_send_owner_income_files(){
      return this.business.personal.guarantee_profile.income_files_required;
    },
    should_fill_owner_mexican_address(){
      return this.business.personal.address.country_id == this.mexicoCountryId;
    },
    should_fill_owner_foreign_address(){
      return this.business.personal.address.country_id != this.mexicoCountryId;
    },
    should_fill_owner_bdate_gender(){
      return this.businessOwner.citizenship == this.mexicoCountryId;
    },
     should_fill_owner_rfc_curp_fiscal_rec(){
      return this.businessOwner.citizenship == this.mexicoCountryId;
    },
    shoulf_fill_mexican_guarantee_address(){
      if(!this.pf_guarantee_address){
        return false;
      }
      return this.pf_guarantee_address.country_id == this.mexicoCountryId;
    },
    should_fill_foreign_guarantee_address(){
      if(!this.pf_guarantee_address){
        return false;
      }
      return this.pf_guarantee_address.country_id != this.mexicoCountryId;
    },
    client_should_be_married(){
      return this.personal.marital_status == this.marriedMaritalStatusId;
    },
    owner_should_be_married(){
      return this.business.personal.marital_status == this.marriedMaritalStatusId;
    },
    pf_guarantee_should_be_married(){
      if(this.pf_guarantee_personal){
        return this.pf_guarantee_personal.marital_status == this.marriedMaritalStatusId;
      }
      return false;
    },
    is_project_view(){
      return true;
    },
    personalBankAccount(){
      return this.base.client.user.personal.bank_accounts[0];
    },
    businessBankAccount(){
      return this.base.client.user.business.bank_accounts[0];
    },
    businessOwner(){
      return this.base.client.user.business.personal;
    },
    client_bank_account_id(){
      if(!this.client_bank_account_exists){
        return null;
      }

      if(this.isMoral){
        return this.businessBankAccount.id
      }
      else {
        return this.personalBankAccount.id;
      }
    },
    client_bank_account_exists(){
      if(this.isMoral){
        return this.businessBankAccount ? this.businessBankAccount.id != null : false;
      }
      else {
        return this.personalBankAccount ? this.personalBankAccount.id != null : false;
      }
    },
    showObligatedTab(){
      if(this.isPfae){
        return this.personal.credit_profile.guarantee_required;
      }
    },
    personal_credit_profile(){
      if(this.isMoral){
        return null;
      }
      else {
        if(this.personal){
          return this.personal.credit_profile;
        }
      }
    },
    business_credit_profile(){
      if(!this.isMoral){
        return null;
      }
      else {
        if(this.business){
          return this.business.credit_profile;
        }
      }
    },
    client_should_be_working() {
        return this.personal.credit_profile.current_employment == 1 ? true : false;
    },
    client_should_not_be_working() {
        return this.personal.credit_profile.current_employment == 0 ? true : false;
    },
    client_should_be_working_and_not_the_same_address() {
      return (this.personal.credit_profile.current_employment == 1 && this.cpAddressSource == 2) ? true : false;
    },
  },
  async beforeMount() {
    this.loading = true;
    this.isMounted = false;
    await this.getCollections();
    await this.getProjectData();
    await this.getProjectStatusInfo();
    this.setClientPersonTypeInfo();
    await this.setCustomIntegrations();
    await this.getFormInfo();
    this.setSectionGroups();
    this.setBlockedDocuments();
    this.isMounted = true;
    this.loading = false;
  },
  watch: {
    loading : function(newVal, oldVal){
      if(newVal == true){
         this.$vs.loading();
      }
      else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    getSectionsForGroup(group){
      let sections = group.sections.filter(f => f.data.fields.length > 0);
      if(!this.hasBackofficeAccess && !this.legal_owner_document_required){
        sections = sections.filter(f => f.data.id != 29);
      }
      if(!this.showObligatedTab){
        sections = sections.filter(f => f.data.id != 19 && f.data.id != 20 && f.data.id != 21);
      }
      return sections;
    },
    async reloadFormInfo(){
      this.isRefreshing = true;
      await this.getProjectData();
      await this.setCustomIntegrations();
      this.reloadSectionGroups();
      this.isRefreshing = false;
    },
    async saveGroupChanges(section){
      let result = await this.runValidations(section);
      if(!result){
       this.missingFieldsNotif();
      }
      else {
        this.loading = true;

        //guardar solo la informacion que se ha modificado
        this.basePayload = this.collectFormData(section);

        // conversion de finance.deposit_percentage
        let finance = this.basePayload.finance;
        if(finance && finance.deposit_percentage_unit){
          finance.deposit_percentage = finance.deposit_percentage_unit / 100;
        }

        if(this.objectIsEmpty(this.basePayload)){
          //this.notFieldsToUpdate();
          this.saveSuccessNotif();
          this.loading = false;
          return;
        }

        this.basePayload.id = this.base.id;

        try {
          // ejecutar guardado
          let response = await axios.put(`/api/v2/projects/${this.id}/deepUpdate`, this.basePayload);
          console.log(response.data);
          // solicitar la informacion actualizada del modelo
          await this.reloadFormInfo();

          this.saveSuccessNotif();
        }
        catch (error) {
          this.failedOperationNotif(null, null);
        }

        this.loading = false;
      }
    },
    async runValidations(section){
       // validar componentes tipo FormField
       let gslug = "section" + section.data.id;
      let res1 = await this.validateFormFields(gslug);
      if(!res1){
        return false;
      }

      // validar inputs instanciados en la vista
     /* let res2 = await this.$validator.validateAll();
      if(!res2){
        return false;
      }*/

      // inspeccionar los campos para ejecutar validaciones especiales
      let spValidation = await this.checkFormFieldsSpecialValidations(gslug);
      if(!spValidation){
        return false;
      }

      // inspeccionar los campos agregados directo en el componente para ejecutar validaciones especiales

      let sp_failed = false;

        section.data.fields.filter(f => f.special_definition == 1).forEach(f => {
          // considerar los campos habilitados (visibles), con validaciones especiales
          if(this.fields[f.fname] && f.special_validation != null && f.special_validation.method != null) {
            let res = this[f.special_validation.method]();

            if(!res){
              this.errors.add({
                field: f.fname,
                msg: f.special_validation.error
              });
              this.missingFieldsNotif(f.field_name, f.special_validation.error, 10000);
              sp_failed = true;
            }
          }
        });

      if(sp_failed){
        return false;
      }

      // retornar true si todas las validaciones fueron positivas
      return true;
    },
    collectFormData(section){
      let payload = {};
        section.containers.forEach(cc => {
          let fields = this.validatedFields.filter(vf => vf.db == cc.db);
          if(fields.length < 1){
            return;
          }

          if(cc.path == "base"){
            fields.forEach(f => {
              payload[f.fname] = cc.container[f.fname];
            });
          }
          else {
            let obj = null;
            if(arrayPaths.includes(cc.path)){
              // se integran todos los objetos de la coleccion
              obj = this.nestedFieldValue(this.base, cc.path);
            }
            else {
              obj = {id: cc.container.id};
              fields.forEach(f => {
                obj[f.fname] = cc.container[f.fname];
              });
            }
            // ajuste para objetos tipo array
            this.setNestedObjectWithIds(payload, this.base, cc.path, obj);
          }
        });
      return payload;
    },
    async validateFormFields(refGroup){
      let allValid = true;
      this.validatedFields = [];
      let grefs = this.$refs[refGroup];
      for(let p in grefs){
        let r = await this.$refs[refGroup][p].checkForValidDirty();
        if(r.valid == false){
          allValid = false;
        }
        else if(r.dirty == true) {
          this.validatedFields.push(r);
        }
      }
      return allValid;
    },
    async checkFormFieldsSpecialValidations(refGroup){
      let spvalid = true;
      let grefs = this.$refs[refGroup];
      let f;
      for(let p in grefs){
        f = grefs[p];

        let bck = f.checkBackofficePermit();
        if(!bck){
          continue;
        }

        let sp = f.specialValidation();
        if(sp != null && sp.method in this){
          let res = await this[sp.method]();
          let n = f.rawFieldName;
          if(f.f.db_field === "rfc") {
            if(res.length === 0) {
              continue;
            } else {
              spvalid = false;
              res.forEach(item => {
                this.errorNotif(item.n, item.e, 10000);
              })
            }
          }
          if(!res){
            spvalid = false;
            f.setError(sp.error);
            this.errorNotif(n, sp.error, 10000);
          }
        }
      }
      return spvalid;
    },
    async onFieldChange(method){
      if(method != null && method in this){
        await this[method]();
      }
    },
    /* evaluator */
    evaluateCondition(condition){
      return this.evaluateConditionBase(this, condition);
    },

    /* obtener ids para los casos correspondientes */
    docTargetEvaluator(cls, cls_2){
      if(cls == 'user'){
        if(cls_2 == 'supplier'){
          return this.UserId;
        }
        else if(cls_2 == 'applicant'){
          return this.base.client.user.id;
        }
      }
      else if(cls == 'project'){
        return this.currentProjectId;
      }
      this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
      return null;
    },

    setClientPersonTypeInfo(){
      this.isMoral = this.person_type == this.pmClientType;
      this.isPfae = this.person_type == this.pfClientType;
      this.tabs = this.isMoral ? pmTabsDefs : pfTabsDefs;

      if(this.isPfae && this.personal.tax_profile == this.PFAE_TAX_PROFILE){
        this.isRealPFAE = true;

        // agregar seccion de constancia fiscal
        if(!this.tabs[0].sections.find(f => f == this.pfaeExtraSection)){
          this.tabs[0].sections.push(this.pfaeExtraSection);
        }
      }
    },
    async setCustomIntegrations(){
      // direcciones personal profile
      let padd_sid = this.nestedFieldValue(this.base, 'client.user.personal.address.state_id');
      if(padd_sid != null){ await this.reload_personal_cities() }

      // direcciones business profile
      let badd_sid = this.nestedFieldValue(this.base, 'client.user.business.address.state_id');
      if(badd_sid != null){ await this.reload_business_cities() }

      let guaran_cid = this.nestedFieldValue(this.base, 'client.user.personal.guarantee_profile.personal.address.country_id');
      if(guaran_cid != null){ this.update_personal_guarantee_country_id() }

      let guaran_sid = this.nestedFieldValue(this.base, 'client.user.personal.guarantee_profile.personal.address.state_id');
      if(guaran_sid != null){ await this.reload_personal_guarantee_cities() }

      // let employer_add_id = this.nestedFieldValue(this.base, 'client.user.personal.credit_profile.employer_address_id');
      let client_add_id = this.nestedFieldValue(this.base, 'client.user.personal.address_id');
      let employer_add_id = null;

      if(employer_add_id != null && client_add_id != null){
        if(employer_add_id == client_add_id){
          this.base.client.user.personal.credit_profile.select_address_source = 1;
          this.cpAddressSource = 1;
        }
        else {
          this.base.client.user.personal.credit_profile.select_address_source = 2;
          this.cpAddressSource = 2;
        }
      }

      // let employer_sid = this.nestedFieldValue(this.base, 'client.user.personal.credit_profile.address.state_id');
      // if(employer_sid != null){ await this.reload_personal_credit_profile_cities() }


      // conversion finance.deposit_percentage
      let finance = this.base.finance;
      if(finance && finance.deposit_percentage != null){
        finance.deposit_percentage_unit = finance.deposit_percentage * 100;
      }
    },
    setSectionGroups(){
      this.tabs.forEach(t => {
        let group = { title: t.title, icon: t.icon, slug: t.slug }; //, vModel: this.getModelForGroup(t.slug) };
        let sections = [];

        t.sections.forEach(ss => {
          let s = this.allSections.find(f => f.id == ss);
          if(s != null){
            let sb = { data: s, containers: this.getContainersForSection(s.id) };
            sections.push(sb);
          }
          else {
            this.warn("Section " + ss + " not found");
          }
        })
        group.sections = sections;
        this.sectionGroups.push(group);
      });
    },
    reloadSectionGroups(){
      this.sectionGroups.forEach(group => {
        group.sections.forEach(s => {
          s.containers = this.getContainersForSection(s.data.id);
        })
      });
    },
    setBlockedDocuments(){
      this.validatedDocuments.forEach(doc => {
        this.allSections.forEach(section => {
          let ffs = section.fields.filter(f => f.block_by_document_id == doc);
          ffs.forEach(fd => fd.blockedByDocument = true);

          if(ffs.length == section.fields.filter(f => f.doc_id == null ).length){
            section.skipBtn = true;
          }
        })
      })
    },
    getContainerForField(section, f){
      let c = section.containers.find(sc => sc.db == f.db_table);
      if(!c){
        this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
        return null;
      }
      else {
        return c.container;
      }
    },
    getContainersForSection(section_id){
      let c = sectionsToContainers.find(f => f.id == section_id);
      if(!c){
        this.warn("Missing containers definition for section " + section_id);
        return null;
      }
      else {
        let sectionContainers = [];
        c.containers.forEach(cc => {
          let con = this.setContainerFromDef(cc);
          sectionContainers.push({db: cc.db, path: cc.path, container: con});
        })
        return sectionContainers;
      }
    },
    setContainerFromDef(c){
      let container = this.nestedFieldValue(this.base, c.path);
      if(Array.isArray(container)){
        let ac = null;
        if(c.arrayDefs){
          if(c.arrayDefs.getFirst == true){
            ac = container[0];
          }
          else if(c.arrayDefs.eval){
            // llamado en funciones de secciones
            ac = this[c.arrayDefs.eval](container);
          }
        }
        if(!ac){
          if(c.arrayDefs.onNull){
            if(c.arrayDefs.onNull in this) {
              ac = this[c.arrayDefs.onNull]();
            }
            else {
              this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.arrayDefs.onNull );
            }
          }
          else { ac = {} }
          container.push(ac);
        }
        return ac;
      }
      else {
        if(!container && c.objDefs && c.objDefs.onNull){
          if(c.objDefs.onNull in this) {
              container = this[c.objDefs.onNull]();
            }
            else {
              this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.objDefs.onNull );
            }
        }
        if(!container){
          container = {};
        }
        return container;
      }
    },
    async getProjectStatusInfo(){
      // TODO
    },
    async getProjectData(){
      try{
        // ?filter[status]=3 // ejemplo de filtro
        let params = "with[]=" + requiredObjects.join("&with[]=");
        let response = await axios.get(`/api/v2/projects/${this.id}?${params}`);
        this.base = response.data;
        this.isMaster = this.base.splits.length > 0;
      }
      catch(e){
        this.warn(e);
        this.failed = true;
      }
    },
    async getFormInfo(){
      try{
        let id = this.isMoral == true ? this.flow_id_pm : this.flow_id_pf;
        let response = await axios.get("/api/v1/forms/getFlowSectionFields/" + id);
        let url = this.ApiDomain + `/storagev3/documents/flow/${id}`;
        let response2 = await axios.get(url);
        this.documentsStates = response2.data;

        this.flow = response.data.flow;
        this.allSections = response.data.sections;

        await this.asyncForEach(this.allSections, async (s) => {
          if(this.tabs.filter(tt => tt.sections.includes(s.id)).length < 1){
            return;
          }

          s.documentFields = [];
          let co = 0;
          await this.asyncForEach(s.fields, async (f) => {
            this.formFieldSetter(f, this);
            if (this.isAutoFieldToSave(f)) {co += 1}

            // check for documents
            if(f.doc_id != null){
              let ff = {formField: f, documentSet: null, target_id: null };
              let ss = this.documentsStates.find(sid => sid.id == s.id);
              if(ss && ss.documents){
                let dset = ss.documents.find(d => d.id == f.doc_id);
                if(dset){
                  ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                  ff.documentSet = dset;
                }
              }
              s.documentFields.push(ff);
              this.allDocumentFields.push(ff);
            }
          })

          if(co == 0){
            s.skipBtn = true;
          }
        });

         let res = await this.getAllDocumentsStates(this.allDocumentFields, this.evaluateCondition);
        if(res){
          this.allDocumentFields.forEach(f => {
            if(f.loadedState && f.loadedState.is_verified == verifiedEnumValue){
              this.validatedDocuments.push(f.documentSet.id);
            }
          })
        }
      }
      catch(e){
        this.warn(e);
        this.failed = true;
      }
    },
    onDocumentUploadSuccess(data){
      let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
      d.loadedState = data;
    },
    async getCollections(){
      try {
        let collectionsObjects = ['countriesList', 'statesList', 'familyGroups', 'personalOccupationsList',
        'projectValidTerms', 'personalOccupationsList', 'businessActivities', 'banksForMexico', 'coverImagesList'];

        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
        this.collections.countries = res.data.countriesList;
        this.collections.states = res.data.statesList;
        this.collections.family_groups = res.data.familyGroups;
        this.collections.personal_occupations = res.data.personalOccupationsList;
        this.collections.terms = res.data.projectValidTerms;
        this.collections.banks = res.data.banksForMexico;
        this.collections.cover_images = res.data.coverImagesList;
        this.collections.business_activities = res.data.businessActivities;
      }
      catch (e) {
        this.warn(e);
        this.failed = true;
      }
    },
    processError(code){
      this.onError = true;
      this.errorCode = code;
    },

    /* on_change methods */
    owner_curp_conditions_changed(){
      this.trigger_curp_conditions_changed(this.businessOwner);
    },

    client_curp_conditions_changed(){
      this.trigger_curp_conditions_changed(this.personal);
    },

    trigger_curp_conditions_changed(obj){
      let c = obj["curp"];
      if(!c){ return; }
      if(c.length >= 10){
        let yy = c.slice(4,6);
        let mm = c.slice(6,8);
        let dd = c.slice(8,10);

        let date = this.getDateFromInputs(yy, mm, dd);
        if(date === false){
          obj["birth_date"] = null;
        }
        else{
          obj["birth_date"] = date;
        }
      }
      else{
        obj["birth_date"] = null;
      }

      if(c.length >= 11){
        let g = c.slice(10, 11);
        if(g == "H"){
          obj["gender"] = 1;
        }
        else if(g == "M"){
          obj["gender"] = 2;
        }
        else{
          obj["gender"] = null;
        }
      }
      else{
        obj["gender"] = null;
      }
    },

     /* on_change methods */
    async reload_personal_cities(){
      try {
        let sid = this.personal.address.state_id;
        let res = await axios.get(`/api/register/cities/${sid}`);
        this.collections.cities = res.data;
        if(this.isMounted && !this.isRefreshing) this.personal.address.city_id = null;
      } catch (e) {
        this.warn(e);
      }
    },
    async reload_business_cities(){
      try {
        let sid = this.business.address.state_id;
        let res = await axios.get(`/api/register/cities/${sid}`);
        this.collections.cities = res.data;
        if(this.isMounted && !this.isRefreshing) this.business.address.city_id = null;
      } catch (e) {
        this.warn(e);
      }
    },
    async reload_personal_guarantee_cities(){
      try {
        let sid = this.personal.guarantee_profile.address.state_id;
        let res = await axios.get(`/api/register/cities/${sid}`);
        this.collections.cities = res.data;
        if(this.isMounted && !this.isRefreshing) this.personal.guarantee_profile.address.city_id = null;
      } catch (e) {
        this.warn(e);
      }
    },
      async reload_business_owner_cities(){
      try {
        let sid = this.business.personal.address.state_id;
        let res = await axios.get(`/api/register/cities/${sid}`);
        this.collections.owner_cities = res.data;
        if(this.isMounted && !this.isRefreshing) this.business.personal.address.city_id = null;
      } catch (e) {
        this.warn(e);
      }
    },
    /**
     * TODO-DELETE
     * 04/01/2023
     */
    async reload_personal_credit_profile_cities(){
      try {
        let sid = this.personal.credit_profile.address.state_id;
        let res = await axios.get(`/api/register/cities/${sid}`);
        this.collections.employer_cities = res.data;
        if(this.isMounted && !this.isRefreshing) this.personal.credit_profile.address.city_id = null;
      } catch (e) {
        this.warn(e);
      }
    },

    update_cp_address_source(){
      this.cpAddressSource = this.personal.credit_profile.select_address_source;
    },

    update_net_income(){
      if(this.base.finance){
        // let i1 = this.personal_credit_profile.average_income_1;
        // let i2 = this.personal_credit_profile.average_income_2;
        // let i3 = this.personal_credit_profile.average_income_3;
        let sum = 0;
        let count = 0;
        // if(i1 != null){
        //   sum += parseFloat(i1);
        //   count += 1;
        // }
        // if(i2 != null){
        //   sum += parseFloat(i2);
        //   count += 1;
        // }
        // if(i3 != null){
        //   sum += parseFloat(i3);
        //   count += 1;
        // }

        if(count == 0){
          this.personal_credit_profile.net_income = 0;
        }
        else {
          this.personal_credit_profile.net_income = (sum / count).toFixed(2);
        }
      }
    },

    /**
     * TODO-DELETE
     * 04/01/2023
     */
    update_business_net_income(){
      // if(this.base.finance){
      //   let i1 = this.business_credit_profile.average_income_1;
      //   let i2 = this.business_credit_profile.average_income_2;
      //   let i3 = this.business_credit_profile.average_income_3;
      //   let sum = 0;
      //   let count = 0;
      //   if(i1 != null){
      //     sum += parseFloat(i1);
      //     count += 1;
      //   }
      //   if(i2 != null){
      //     sum += parseFloat(i2);
      //     count += 1;
      //   }
      //   if(i3 != null){
      //     sum += parseFloat(i3);
      //     count += 1;
      //   }

      //   if(count == 0){
      //     this.business_credit_profile.net_income = 0;
      //   }
      //   else {
      //     this.business_credit_profile.net_income = (sum / count).toFixed(2);
      //   }
      // }
    },

    /* funciones de secciones */
    newBankAccount(){
      return {id: null};
    },
    addPersonalAddress(){
      this.client.user.personal.address = {id: null};
    },

    /* validaciones especiales */
    validate_client_age_legal(){
      let years = this.calculateAgeFromDate(this.personal.birth_date);
      return years >= 18;
    },
    async validate_client_unique_curp(){
     return await this.validate_unique_curp(this.personal.curp, this.personal.id)
    },
    async validate_owner_clabe_is_valid(){
      return this.validate_clabe(this.business.personal.bank_accounts[0].clabe, this.collections.banks);
    },
    async validate_owner_unique_curp(){
      return this.validate_unique_curp(this.businessOwner.curp, this.businessOwner.id)
    },
    async validate_client_unique_rfc(){
     return await this.validate_unique_personal_rfc(this.personal.rfc, this.personal.id)
    },
    async validate_business_unique_rfc(){
      return await this.validate_unique_business_rfc(this.business.rfc, this.business.id)
    },
    async validate_owner_unique_rfc(){
      return this.validate_unique_personal_rfc(this.businessOwner.rfc, this.businessOwner.id)
    },
  }
}
</script>
